const def = {
	inn: {
		label: 'ИНН',
		text: 'Проверить',
		type: 'layer1',
		placeholder: "Введите ИНН",
	},
	source: {
		label: 'Откуда Вы узнали о Нас?',
		text: 'Источники',
		icon: 'pin',
		type: 'layer1',
		placeholder: "Выберите из",
		disabledInput: true,
	},
	login: {
		label: 'Логин',
		autoComplete: 'username',
		icon: 'user',
		type: 'layer1',
		placeholder: 'Введите логин',
	},
	pwd: {
		label: 'Пароль',
		autoComplete: 'new-password',
		content: 'password',
		icon: 'key',
		type: 'layer1',
		placeholder: 'Введите пароль',
	},
	pwd2: {
		label: 'Повторите пароль',
		autoComplete: 'new-password',
		content: 'password',
		icon: 'key',
		type: 'layer1',
		placeholder: 'Введите пароль',
	},
};

export default def;